import { ServerStack } from './server-stack'
import { WarmingTimeline } from './warming-timeline'
import { DeliveryBars } from './delivery-bars'
import { ShieldVisual } from './shield-visual'
import { SlackMockup } from './slack-mockup'

const FEATURES = [
  {
    tag: 'Infrastructure',
    title: 'We own the servers',
    description:
      "Your emails don't go through someone else's infrastructure with a markup on top. We run the actual mail servers in the EU. That's why we're half the price.",
    visual: <ServerStack />,
  },
  {
    tag: 'Deliverability',
    title: 'Fresh IPs, warmed for you',
    description:
      "New sending IPs need to build trust with Gmail and Outlook. We ramp them up automatically over 42 days with adaptive throttling — so your emails land in inbox, not spam.",
    visual: <WarmingTimeline />,
  },
  {
    tag: 'Speed',
    title: 'See where your emails actually land',
    description:
      "Gmail delivery rate vs Outlook vs Yahoo — broken down in your dashboard. Bounce trends, complaint rates, open rates by provider. No vanity metrics, no guessing.",
    visual: <DeliveryBars />,
  },
  {
    tag: 'Protection',
    title: 'Your reputation, protected',
    description:
      "One bad sender can ruin deliverability for everyone on a shared IP. We monitor every account in real time and auto-pause anything suspicious before it damages your sending reputation.",
    visual: <ShieldVisual />,
  },
  {
    tag: 'Monitoring',
    title: 'Know before your users do',
    description:
      "Bounce rate spiking? Domain verification broke? IP warming paused? Get a Slack message the moment something needs your attention. Set your own thresholds — we'll handle the rest.",
    visual: <SlackMockup />,
  },
] as const

export function FeaturesSection() {
  return (
    <section
      style={{
        background: '#FDF8F3', color: '#1a1216',
        padding: '80px 0 40px',
      }}
    >
      {/* Header */}
      <div className="section-pad" style={{ textAlign: 'center', marginBottom: 80 }}>
        <p
          style={{
            fontSize: 14, fontWeight: 700, color: '#FF6B00',
            letterSpacing: '0.08em', textTransform: 'uppercase', marginBottom: 14,
          }}
        >
          Why switch
        </p>
        <h2
          style={{
            fontSize: 'clamp(36px, 4.5vw, 52px)', fontWeight: 800,
            letterSpacing: '-0.03em', lineHeight: 1.1,
            maxWidth: 700, margin: '0 auto',
          }}
        >
          Everything they charge extra for,{' '}
          <span
            style={{
              fontFamily: "var(--oe-font-serif)",
              fontStyle: 'italic', color: '#FF6B00',
            }}
          >
            we include.
          </span>
        </h2>
      </div>

      {/* Zigzag features */}
      <div className="section-pad" style={{ maxWidth: 1100, margin: '0 auto' }}>
        {FEATURES.map((feature, i) => {
          const reversed = i % 2 === 1
          return (
            <div
              key={i}
              className="grid-2col"
              style={{
                gap: 64,
                alignItems: 'center',
                marginBottom: i < FEATURES.length - 1 ? 100 : 40,
                direction: reversed ? 'rtl' : 'ltr',
              }}
            >
              {/* Text */}
              <div style={{ direction: 'ltr' }}>
                <span
                  style={{
                    display: 'inline-block', fontSize: 11, fontWeight: 700,
                    color: '#FF6B00', letterSpacing: '0.08em',
                    textTransform: 'uppercase', marginBottom: 14,
                    padding: '5px 12px', background: '#FFF5ED', borderRadius: 6,
                  }}
                >
                  {feature.tag}
                </span>
                <h3
                  style={{
                    fontSize: 32, fontWeight: 800, letterSpacing: '-0.02em',
                    marginBottom: 16, lineHeight: 1.15,
                  }}
                >
                  {feature.title}
                </h3>
                <p style={{ fontSize: 17, lineHeight: 1.7, color: '#5a5452', maxWidth: 440 }}>
                  {feature.description}
                </p>
              </div>

              {/* Visual */}
              <div
                style={{
                  direction: 'ltr', background: '#fff', borderRadius: 20,
                  border: '1px solid #EDE9E4', padding: '28px 24px',
                  boxShadow: '0 4px 20px rgba(0,0,0,0.04)',
                }}
              >
                {feature.visual}
              </div>
            </div>
          )
        })}
      </div>
    </section>
  )
}
